module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-disabled-tiny.34cbaa24.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-disabled-tiny.png
// module id = 2637
// module chunks = 11